import { useUtilityContext } from "@Context/prompt-toolbox/UtilityContext";
import { FilePlus, FolderPlus, Plus } from "@phosphor-icons/react";
import { useState } from "react";

const AddPrompt = () => {
  const { setView } = useUtilityContext();
  const [toggleAdd, setToggleAdd] = useState(false);

  const showAddDropdown = () => {
    setToggleAdd(!toggleAdd);
    const dropdown = document.getElementById("add-prompt-dropdown");
    if (dropdown) {
      dropdown.classList.toggle("hidden");
      dropdown.classList.add("flex");
    }
  };

  const hideAddDropdown = () => {
    setToggleAdd(false);
    const dropdown = document.getElementById("add-prompt-dropdown");
    if (dropdown) {
      dropdown.classList.toggle("flex");
      dropdown.classList.add("hidden");
    }
  };

  const handleChangeView = (type: string) => {
    setView(type);
  };

  return (
    <>
      <button
        data-testid="add-prompt"
        onClick={showAddDropdown}
        className={`rounded-full ${toggleAdd ? "bg-primary-700 text-white" : "bg-none text-primary-700"} border-2 border-primary-700 p-1 hover:shadow-md`}
      >
        <Plus size={18} weight="bold" />
      </button>

      <div
        id="add-prompt-dropdown"
        onMouseLeave={() => hideAddDropdown()}
        className="absolute right-0 top-11 z-50 hidden flex-col items-start rounded-2xl border border-neutral-400 bg-white p-4 shadow-md"
      >
        <div
        data-testid="new-prompt"
          onClick={() => handleChangeView("New")}
          className="flex w-full cursor-pointer flex-row gap-2 border-l-4 px-2 py-1 text-primary-600 hover:border-primary-700 hover:bg-primary-100"
        >
          <span>
            <FilePlus size={20} weight="regular" />
          </span>
          <span className="text-sm">New Prompt</span>
        </div>

        <div
        data-testid="new-import"
          onClick={() => handleChangeView("Library")}
          className="flex w-full cursor-pointer flex-row gap-2 border-l-4 px-2 py-1 text-primary-600 hover:border-primary-700 hover:bg-primary-100"
        >
          <span>
            <FolderPlus size={20} weight="regular" />
          </span>
          <span className="text-sm">Import</span>
        </div>
      </div>
    </>
  );
};

export default AddPrompt;
